import { loadedImages } from './imageLoader'
import { ICON_DRAWERS } from './iconDrawers'

export function drawIcon(ctx, t) {
  const s = t.size * 0.48
  const a = t.currentAlpha
  const iconColor = t.r < 100
    ? `rgba(255,255,255,${a})`
    : `rgba(30,30,30,${a})`

  ctx.save()
  ctx.translate(t.x, t.y)
  ctx.fillStyle = iconColor
  ctx.strokeStyle = iconColor
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.shadowColor = 'transparent'
  ICON_DRAWERS[t.label]?.(ctx, s)
  ctx.restore()
}

export function drawLabel(ctx, t) {
  const a = t.currentAlpha
  const lx = t.x
  const ly = t.y + t.size + 20
  ctx.save()
  ctx.font = '600 12px system-ui, -apple-system, sans-serif'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  const tw = ctx.measureText(t.label).width
  const pad = 7
  ctx.fillStyle = `rgba(255,255,255,${0.9 * a})`
  ctx.shadowColor = `rgba(0,0,0,${0.08 * a})`
  ctx.shadowBlur = 6
  ctx.shadowOffsetX = 0
  ctx.shadowOffsetY = 2
  ctx.beginPath()
  ctx.roundRect(lx - tw / 2 - pad, ly - 9, tw + pad * 2, 18, 9)
  ctx.fill()
  ctx.shadowColor = 'transparent'
  ctx.fillStyle = `rgba(30,41,59,${a})`
  ctx.fillText(t.label, lx, ly)
  ctx.restore()
}

export function drawTriangle(ctx, t) {
  const a = t.currentAlpha
  const img = loadedImages[t.label]
  if (img) {
    const imgSize = t.size * 2.16
    ctx.save()
    ctx.globalAlpha = a
    ctx.translate(t.x, t.y)
    ctx.rotate(t.rotation)
    ctx.drawImage(img, -imgSize / 2, -imgSize / 2, imgSize, imgSize)
    ctx.restore()
    return
  }

  ctx.save()
  ctx.translate(t.x, t.y)
  ctx.rotate(t.rotation)
  ctx.shadowColor = `rgba(${t.r},${t.g},${t.b},${0.2 * a})`
  ctx.shadowBlur = 24
  ctx.shadowOffsetX = 4
  ctx.shadowOffsetY = 7
  ctx.fillStyle = `rgba(${t.r},${t.g},${t.b},${0.82 * a})`
  ctx.beginPath()
  const s = t.size
  ctx.moveTo(0, -s)
  ctx.lineTo(s * 0.866, s * 0.5)
  ctx.lineTo(-s * 0.866, s * 0.5)
  ctx.closePath()
  ctx.fill()
  ctx.restore()

  drawIcon(ctx, t)
}
